module.exports = __webpack_public_path__ + "static/media/family07.4b1baf4a.png";